import { render, staticRenderFns } from "./CustomerNew.vue?vue&type=template&id=6287e812"
import script from "./CustomerNew.vue?vue&type=script&lang=js"
export * from "./CustomerNew.vue?vue&type=script&lang=js"
import style0 from "./CustomerNew.vue?vue&type=style&index=0&id=6287e812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports